/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */
import dateFormat from './dateFormat';
import TWEEN from '@tweenjs/tween.js';
import QRCode from 'qrcode';

export const urlTool = {
  /*
   * 添加query时判断 ？ 或者 &
   * */
  prefixQuery(argUrl) {
    // let formatUrl =  this.infoWxShareUrl()
    if (argUrl.split('?').length > 1) {
      return '&';
    } else {
      return '?';
    }
  },
  /*
   * 格式化微信分享后的URL 去除分享后微信添加的标识
   * */
  infoWxShareUrl() {
    let shareUrl = location.href;
    if (/\.html\?from\=/.test(shareUrl)) {
      let infoUrl = shareUrl.split('?')[1].split('#')[0];
      let formatReg = new RegExp(infoUrl);
      return shareUrl.replace(formatReg, '').replace(/\?/, '');
    } else {
      return shareUrl;
    }
  }
};
export const transAllTime = input => {
  return dateFormat(input, 'YYYY年MM月DD日 HH时mm分');
};
export const transMonth = input => {
  return dateFormat(input, 'YYYY年MM月');
};

/**
 * 链接转为二维码
 * @param {*} url
 */
export const getQrcodeUrl = (...args) => {
  const canvas = document.createElement('canvas');
  let backUrl = '';
  QRCode.toCanvas(canvas, args[0], error => {
    if (error) console.error(error);
    backUrl = canvas.toDataURL('image/png', 1);
  });
  return backUrl;
};

export const kernel = () => {
  let ua = window.navigator.userAgent.toLowerCase();
  console.log(ua, 'userAgent');
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return 'wx';
  } else {
    if (/android/.test(ua)) {
      return 'android';
    } else if (/iphone|ipad|ipod/.test(ua)) {
      return 'ios';
    } else {
      return 'pc';
    }
  }
};
/**
 * @description: *代替字符串部分内容
 * @param {content} 内容
 * @param {start} 开始部分
 * @param {end} 结束部分
 * @return: String
 */
export const hideSomeString = (content, start = 3, end = 7, stars = 4) => {
  if (!content) return '';
  // return content.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
  content = String(content);
  return content.substr(0, start) + '*'.repeat(stars) + content.substr(end);
};

export function handlePhone(phone, split = ' ') {
  const _phone = `${phone}`;
  if (_phone.length == 11) {
    return _phone.replace(/(^\d{3}|\d{4}\B)/g, '$1' + split);
  } else {
    return phone;
  }
}

// 定时器方案
export const throttle = function (fn, wait) {
  let timer = null;
  return function (...args) {
    let context = this;
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(context, args);
        timer = null;
      }, wait);
    }
  };
};

export const useTWEEN = (
  startValue,
  endValue,
  fn,
  options = { times: 2000 }
) => {
  let tweenAnimate = () => {
    if (TWEEN.update()) {
      requestAnimationFrame(tweenAnimate);
    }
  };
  new TWEEN.Tween({
    total: startValue
  })
    .to(
      {
        total: endValue
      },
      options.times
    )
    .onUpdate(obj => {
      fn(obj);
    })
    .start();
  tweenAnimate();
};
